import { Block, Text } from '@snowflake/core-ui';
import React from 'react';

interface CortexTwoLineTextProps {
  heading: string;
  subheading: string;
  key: string;
}

export const CortexTwoLineText = (props: CortexTwoLineTextProps, key: string) => {
  return (
    <Block key={key}>
      <Text
        weight="semi-bold"
        style={{
          fontSize: '16px',
          lineHeight: '24px',
        }}
      >
        {props.heading}
      </Text>
      <br />
      <Text
        style={{
          fontSize: '16px',
          lineHeight: '24px',
        }}
      >
        {props.subheading}
      </Text>
    </Block>
  );
};
